import { IPromise } from 'angular';
import { IdentifierQuery, IdentifierQueryResultDto } from '../../models';
import { IValueViewModel } from '../../models/viewModels/valueViewModel';
import { IRequestService } from '../request.service';

export interface IdentifierQueryDto {
    query: IdentifierQuery;
    // TODO make type
    users: any[];
}

export interface IIdentifierQueryService {
    getAll(): IPromise<IdentifierQueryDto[]>;
    get(guid: string): IPromise<IdentifierQuery>;
    add(identifierQuery: IdentifierQuery): IPromise<IdentifierQueryResultDto>;
    update(identifierQuery: IdentifierQuery): IPromise<IdentifierQueryResultDto>;
    delete(guid: string): IPromise<IdentifierQuery[]>;
    execute(guid: string): IPromise<IValueViewModel[]>;
    preview(query: IdentifierQuery): IPromise<IValueViewModel[]>;
    resolve(guid: string, begin: string, end: string): IPromise<any[]>;
}

export class IdentifierQueryService implements IIdentifierQueryService {
    static serviceId: string = 'identifierQueryService';
    private _controllerUrl = 'identifierQuery';
    static $inject = ['requestService'];
    constructor(private _requestService: IRequestService) {
    }

    getAll(): IPromise<IdentifierQueryDto[]> {
        return this._requestService.getAtV1(this._controllerUrl);
    }

    get(guid: string): IPromise<IdentifierQuery> {
        return this._requestService.getAtV1(this._controllerUrl + '/' + guid);
    }

    add(identifierQuery: IdentifierQuery): IPromise<IdentifierQueryResultDto> {
        return this._requestService
            .postAtV1<IdentifierQueryResultDto>(this._controllerUrl + '/add', identifierQuery)
            .then((data) => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }

    update(identifierQuery: IdentifierQuery): IPromise<IdentifierQueryResultDto> {
        return this._requestService
            .postAtV1<IdentifierQueryResultDto>(this._controllerUrl + '/update', identifierQuery)
            .then((data) => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }

    delete(guid: string): IPromise<IdentifierQuery[]> {
        return this._requestService
            .postAtV1<IdentifierQuery[]>(this._controllerUrl + '/delete/' + guid)
            .then((data) => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }

    execute(guid: string): IPromise<IValueViewModel[]> {
        const url = `${this._controllerUrl}/execute/${guid}`;
        this._requestService.cleanCacheAtV1(url);
        return this._requestService.getAtV1(url);
    }

    preview(query: IdentifierQuery): IPromise<IValueViewModel[]> {
        return this._requestService.postAtV1(`${this._controllerUrl}/execute`, query);
    }

    resolve(guid: string, begin: string, end: string): IPromise<any[]> {
        return this._requestService
            .getAtV1(`${this._controllerUrl}/resolve/${guid}?beginDate=${begin}&endDate=${end}`);
    }

}
